module.exports = __webpack_public_path__ + "static/media/ribbon.c9a6fdb0.svg";